import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import { getLogin } from "../features/Loginuser";

function CustomerLogin() {
  const login = useSelector(getLogin);
  let params = useParams();
  if (login == null || login == false) {
    return <Navigate to="/" replace={true} />;
  }
  return (
    <>
      <h1>Customer login {params.customer_id}</h1>
    </>
  );
}

export default CustomerLogin;
